/**
 * Reserves space at the bottom of scrollable client pages for the fixed mobile
 * nav bar and protruding workout FAB. Use as the last child in a page content
 * column — avoids conflicts with Tailwind padding shorthands (p-4, p-0, py-6).
 */
export function ClientNavSpacer() {
  return (
    <div
      aria-hidden="true"
      className="w-full shrink-0 pb-client-nav pointer-events-none"
    />
  );
}
